<template>
  <DataList
    title="Специфікації"
    resource="specifications"
    :columns="columns"
    :filter="filter"
    :get-items-fn="getSpecifications"
    search-label="Пошук по назві, розділам та завданню"
    :is-modal="true"
    component-name="Specification"
    :chips-color-fn="setEstimateCellColor"
  >
    <template v-slot:action-buttons>
      <h2 class="subtitle-1 font-weight-medium mx-1 mr-2 mt-1">
        Переліміти
      </h2>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-switch
            v-model="onlyExceededLimit"
            color="primary"
            class="mt-1"
            hide-details
            v-on="on"
            style="max-height: 32px;"
          />
        </template>
        <span>Факт з грейдами більше планової t(avg)</span>
      </v-tooltip>
      <DownloadFile
        :location="`specifications/rpc/export-to-excel`"
        filename="Спецификации"
        extension="xlsx"
        tooltip="Завантажити у форматі Excel"
        :bottom="true"
      />
    </template>
    <template v-slot:filters>
      <v-row no-gutters>
        <v-col md="4" sm="12">
          <UserSelect
            v-model="users"
            :multiple-select="true"
            label="Автор"
            placeholder="Введіть iм’я автора"
            class="ma-1"
          />
        </v-col>
        <v-col md="4" sm="12">
          <ClientSelect v-model="client" label="Клієнт" class="ma-1" />
        </v-col>
        <v-col md="4" sm="12">
          <CustomTextField
            v-model="lead"
            label="Лід"
            append-icon="search"
            :clearable="true"
            class="ma-1"
          />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import { getSpecifications } from "@/backend/specificationsApi.js";
import { getUser } from "@/backend/usersApi.js";
import DownloadFile from "../../../components/DowloadFile.vue";
import UserSelect from "../../system/users/UserSelect.vue";
import ClientSelect from "../../../components/selects/ClientSelect.vue";
import CustomTextField from "../../../components/CustomTextField.vue";
import { getClient } from "@/backend/clientsApi.js";

export default {
  name: "Specifications",
  components: {
    DownloadFile,
    UserSelect,
    ClientSelect,
    CustomTextField,
  },
  data: () => ({
    columns: [
      {
        title: "id",
        name: "id",
        dataPath: "id",
        sortable: true,
        isDesc: null,
        width: 65,
      },
      {
        title: "Дата",
        name: "createdAt",
        dataPath: "createdAt",
        type: "date",
        width: 50,
        sortable: true,
        isDesc: null,
      },
      {
        title: "Автор",
        name: "author",
        dataPath: "author.title",
        rowType: "wide",
        width: 225,
      },
      {
        title: "Клієнт",
        name: "client",
        dataPath: "client.title",
        width: 100,
        rowType: "wide",
        sortable: true,
        isDesc: null,
      },
      {
        title: "Лід",
        name: "lead",
        dataPath: "lead",
        width: 100,
        defaultPadding: true,
        tooltipData: true,
      },
      {
        title: "Найменування специфікації",
        name: "title",
        dataPath: "title",
        rowType: "wide",
        width: 212,
        sortable: true,
        isDesc: null,
      },
      { title: "t (avg)", name: "tAvg", dataPath: "tAvg", width: 100 },
      {
        title: "min",
        name: "estimateMin",
        rowType: "wide",
        align: "center",
        isColoredChip: true,
        isDesc: null,
      },
      {
        title: "norm",
        name: "estimateNorm",
        dataPath: "estimateAvg",
        rowType: "wide",
        align: "center",
        isColoredChip: true,
      },
      {
        title: "max",
        name: "estimateMax",
        rowType: "wide",
        align: "center",
        isColoredChip: true,
      },
      {
        title: "Факт",
        name: "totalTimeSpentSeconds",
        align: "center",
        type: "dateHours",
      },
      {
        title: "Факт з грейдами",
        name: "factWithGrades",
        align: "center",
        isColoredChip: true,
      },
      {
        title: "Прогрес розробки",
        tooltip: "Факт з грейдами поділено на t (avg)",
        name: "devProgress",
        dataPath: "devProgress",
        type: "circularProgress",
        width: 160,
        align: "center",
      },
    ],
    users: [],
    client: null,
    lead: null,
    onlyExceededLimit: false,
  }),
  computed: {
    filter() {
      return {
        users: [...new Set(this.users.map((u) => u))],
        client: {
          id: this.client ? this.client.id : "",
          title: this.client ? this.client.title : "",
        },
        lead: this.lead ? this.lead : "",
        onlyExceededLimit: this.onlyExceededLimit,
      };
    },
  },
  created() {
    this.getUser();
    this.getClient();
    this.getLead();
  },
  methods: {
    getSpecifications(...args) {
      return getSpecifications(args[0], args[1], args[2], args[3], args[4]);
    },
    setEstimateCellColor(item, estimateName) {
      switch (true) {
        case estimateName === "estimateMin" &&
          item.factWithGrades <= item.estimateMin:
          item.factWithGradesColor = "green";
          item.color = "green";
          return "green";
        case estimateName === "estimateNorm" &&
          item.factWithGrades > item.estimateMin &&
          item.factWithGrades <= item.estimateNorm:
          item.factWithGradesColor = "yellow darken-2";
          item.color = "yellow darken-2";
          return "yellow darken-2";
        case estimateName === "estimateMax" &&
          item.factWithGrades > item.estimateNorm:
          item.factWithGradesColor = "red";
          item.color = "red";
          return "red";
        case estimateName === "factWithGrades":
          return item.factWithGradesColor;
        default:
          return "default";
      }
    },
    async getUser() {
      const userId = this.$router.currentRoute.query.userId;
      if (!userId) {
        return;
      }
      const result = await getUser(userId);
      this.users.push({
        id: result.id,
        title: result.title,
      });
    },
    async getClient() {
      const clientId = this.$router.currentRoute.query.clientId;
      if (!clientId) {
        return;
      }
      const result = await getClient(clientId);
      this.client = {
        id: result.id,
        title: result.title,
      };
    },
    getLead() {
      this.lead = this.$router.currentRoute.query.lead;
    },
  },
};
</script>
